"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const component_link_1 = require("@patternplate/component-link");
exports.SearchTrigger = function SearchTrigger(props) {
    return (React.createElement(component_link_1.Link, { className: props.className, query: {
            "search-enabled": true,
            search: `${props.field}=${props.search}`
        }, title: `Search other patterns with ${props.field} "${props.search}"` }, props.children));
};
//# sourceMappingURL=search-trigger.js.map